import React from 'react';
import '../../Default.css';
import mapsData from "./polandMap.json"
import ZoomableImageType from '../../components_ui/zoomable-image/zoomableImageType';
import ZoomableImage from '../../components_ui/zoomable-image/ZoomableImage';
const map: ZoomableImageType = mapsData as any;

function Polandmap() {
  return (
    <>
      <div className="page-title">
        Map of Poland
      </div>
      <ZoomableImage image={map} />
    </>
  );
}

export default Polandmap;
